import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/correct.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-c6d5a574")

_pushScopeId("data-v-c6d5a574")
const _hoisted_1 = { class: "head-bar" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "left" }, [
  /*#__PURE__*/_createVNode("div", { class: "logo" }, [
    /*#__PURE__*/_createVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createVNode("span", null, "机票预订-管理员系统")
], -1)
const _hoisted_3 = { class: "right" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("span", null, " 管理员：" + _toDisplayString(_ctx.adminName), 1),
      _createVNode("div", {
        class: "out",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.out && _ctx.out(...args)))
      }, "注销")
    ])
  ]))
})